"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ClipboardCheck, House, DollarSign } from "lucide-react";
export default function HowItWorks() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    icon: House,
    title: "Submit Your Property",
    description: "Fill out our quick form with details about your home. No lengthy paperwork or hassle—just a few clicks to get started.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "delay-0"
  }, {
    icon: ClipboardCheck,
    title: "Receive a Cash Offer",
    description: "Our team evaluates your property and presents a transparent, all-cash offer within 24 hours. No waiting, no guesswork.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "delay-100"
  }, {
    icon: DollarSign,
    title: "Close & Get Paid",
    description: "We handle all fees—title, closing, and transfer—so you walk away with your money fast. Simple, secure, and stress-free.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "delay-200"
  }];
  return <section id="how-it-works" className="bg-background py-16 px-6 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground text-center mb-12">
          How It Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <div key={i} data-index={i} ref={step.ref} className={`transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${step.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${step.delay}`}>
                <Card className="h-full border border-border shadow-soft hover:shadow-medium transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1">
                  <CardContent className="flex flex-col items-center text-center gap-4 pt-6">
                    <div className="group inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:bg-primary/20">
                      <IconComponent className="w-8 h-8 text-primary transition-colors duration-[250ms] group-hover:text-primary-hover" />
                    </div>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold text-foreground">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}